import { useEffect, useState } from 'react';

/**
 * Meio segundo de silêncio antes de ir ao servidor.
 *
 * Sem isto, o termo digitado entra direto na chave da consulta e "administrador"
 * são doze requisições — doze entradas de cache, e, em rede ruim, respostas
 * chegando fora da ordem em que foram pedidas.
 *
 * Morava duas vezes, copiada em `UsersScreen` e `MembersScreen`, com o
 * comentário "quando a terceira tela precisar, ela sobe para `lib/`". A terceira
 * e a quarta chegaram — a fila de demandas e a trilha de auditoria — e as duas
 * tinham nascido sem ela, que é exatamente o que acontece enquanto a peça é uma
 * função privada de arquivo de tela.
 */
export function useDebouncedTerm<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
